import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import { RawHtml } from '../../../../common/index.jsx';
import '../../../../common/styles/DetailTable.sass';
import '../../../../common/styles/RichContent.sass';

const DissertationShowDetail = ({ dissertationDetail }) => {
  const { t } = useTranslation();

  if (!dissertationDetail) {
    return null;
  }

  const summaryFileExists =
    dissertationDetail.summary_file !== null &&
    dissertationDetail.summary_file !== '' &&
    Boolean(dissertationDetail.summary_file_url);
  const fulltextFileExists =
    dissertationDetail.fulltext_file !== null &&
    dissertationDetail.fulltext_file !== '' &&
    Boolean(dissertationDetail.fulltext_file_url);
  const hasReviewer = (reviewer) =>
    reviewer !== null &&
    reviewer !== undefined &&
    String(reviewer).trim() !== '';

  const abstracts = [
    {
      key: 'sk',
      label: t('Abstrakt (slovensky)'),
      content: dissertationDetail.abstract_sk,
    },
    {
      key: 'en',
      label: t('Abstrakt (anglicky)'),
      content: dissertationDetail.abstract_en,
    },
  ];

  return (
    <>
      <div className="detail-collapse">
        <CollapseBlock
          collapsible
          title={t('Základné informácie')}
          style={{ marginBottom: '16px' }}
        >
          <table className="table table-striped detail-info-table">
            <tbody>
              <tr>
                <td>
                  <b>{t('Názov práce')}</b>
                </td>
                <td>{dissertationDetail.title}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Autor')}</b>
                </td>
                <td>{dissertationDetail.student}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Školiteľ')}</b>
                </td>
                <td>{dissertationDetail.supervisor}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Dátum obhajoby')}</b>
                </td>
                <td>{dissertationDetail.year}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Študijný program')}</b>
                </td>
                <td>{dissertationDetail.study_program.name}</td>
              </tr>
            </tbody>
          </table>
        </CollapseBlock>

        <CollapseBlock
          collapsible
          title={t('Oponenti')}
          style={{ marginBottom: '16px' }}
        >
          <table className="table table-striped detail-info-table">
            <tbody>
              {hasReviewer(dissertationDetail.reviewer1) && (
                <tr>
                  <td>
                    <b>{t('Oponent')} 1</b>
                  </td>
                  <td>{dissertationDetail.reviewer1}</td>
                </tr>
              )}
              {hasReviewer(dissertationDetail.reviewer2) && (
                <tr>
                  <td>
                    <b>{t('Oponent')} 2</b>
                  </td>
                  <td>{dissertationDetail.reviewer2}</td>
                </tr>
              )}
              {hasReviewer(dissertationDetail.reviewer3) && (
                <tr>
                  <td>
                    <b>{t('Oponent')} 3</b>
                  </td>
                  <td>{dissertationDetail.reviewer3}</td>
                </tr>
              )}
            </tbody>
          </table>
        </CollapseBlock>

        <CollapseBlock collapsible title={t('Abstrakt a texty')}>
          {abstracts.map(({ key, label, content }) => (
            <section key={key} className="detail-rich-section">
              <div className="detail-rich-section__title">{label}</div>
              {content ? (
                <RawHtml className="rich-content" lang={key}>
                  {content}
                </RawHtml>
              ) : (
                '–'
              )}
            </section>
          ))}
          {(summaryFileExists || fulltextFileExists) && (
            <table className="table table-striped detail-info-table">
              <tbody>
                {summaryFileExists && (
                  <tr>
                    <td>
                      <b>{t('Autoreferát')}</b>
                    </td>
                    <td className="add-icons-to-file-anchors">
                      <a
                        href={dissertationDetail.summary_file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('Autoreferát dizertačnej práce')}
                      </a>
                    </td>
                  </tr>
                )}
                {fulltextFileExists && (
                  <tr>
                    <td>
                      <b>{t('Text práce')}</b>
                    </td>
                    <td className="add-icons-to-file-anchors">
                      <a
                        href={dissertationDetail.fulltext_file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('Text práce')}
                      </a>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </CollapseBlock>
      </div>
    </>
  );
};

DissertationShowDetail.propTypes = {
  dissertationDetail: PropTypes.object,
};

export default DissertationShowDetail;
